import React, { forwardRef } from 'react';
import TextareaAutosize, { TextareaAutosizeProps } from '@mui/material/TextareaAutosize';
import { useForkRef } from '@mui/material/utils';
import useTextareaScrollFade from './useTextareaScrollFade';

/** Composer textarea: autosizing and scroll fades share the form-field behavior. */
const ScrollFadeTextarea = forwardRef<HTMLTextAreaElement, TextareaAutosizeProps>((props, ref) => {
  const fadeRef = useTextareaScrollFade(props.value);
  const inputRef = useForkRef(ref, fadeRef);
  return <TextareaAutosize {...props} ref={inputRef} />;
});

export default ScrollFadeTextarea;
